AOS.init({
  once: true,
  duration: 1200,
  offset: 120
});

jQuery(document).ready(function($) {

// Select all Swiper containers
var swiperElements = document.querySelectorAll(".mySwiper");

swiperElements.forEach((swiperElement, index) => {
  var swiperElementParent = swiperElement.closest(".swiper-main");
  // Get the specific pagination and navigation elements for this swiper instance
  var paginationClass = `.expert-pagination-${index}`;
  var nextButtonClass = `.swiper-button-next-${index}`;
  var prevButtonClass = `.swiper-button-prev-${index}`;

  // Add unique class names to pagination and navigation elements
  swiperElementParent.querySelector(".expert-pagination").classList.add(`expert-pagination-${index}`);
  swiperElementParent.querySelector(".swiper-button-next").classList.add(`swiper-button-next-${index}`);
  swiperElementParent.querySelector(".swiper-button-prev").classList.add(`swiper-button-prev-${index}`);

  // Initialize Swiper instance
  var swiper = new Swiper(swiperElement, {
    slidesPerView: 3,
    spaceBetween: 19,
    pagination: {
      el: paginationClass,
      clickable: true,
    },
    navigation: {
      nextEl: nextButtonClass,
      prevEl: prevButtonClass,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 19
      }
    }
  });
});

    var swiper = new Swiper(".mySwiper2", {
      slidesPerView: 3,
      spaceBetween: 19,
      pagination: {
        el: ".poadcast-pagination",
        clickable: true,
      },
        navigation: {
          nextEl: ".poadcast-next",
          prevEl: ".poadcast-prev",
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          // when window width is >= 640px
          992: {
            slidesPerView: 3,
            spaceBetween: 19
          }
        }
      });
      var swiper = new Swiper(".mySwiper3", {
        slidesPerView: 3,
        spaceBetween: 19,
        pagination: {
          el: ".videos-pagination",
          clickable: true,
        },
          navigation: {
            nextEl: ".videos-next",
            prevEl: ".videos-prev",
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 2,
            },
            // when window width is >= 640px
            992: {
              slidesPerView: 3,
              spaceBetween: 19
            }
          }
        });
      document.querySelectorAll(".load-btn").forEach(function(btn, index) {
        btn.addEventListener("click", function(e) {
          e.preventDefault();
          const insightBottom = document.querySelectorAll(".insight-bottom")[index]; // Get the corresponding .insight-bottom element
          if (insightBottom) {
            insightBottom.style.display = "block"; // Show the corresponding .insight-bottom element
          }
      
          const mainBtnDiv = btn.closest(".main-btn-div"); // Get the closest parent element with class .main-btn-div
          if (mainBtnDiv) {
            mainBtnDiv.style.display = "none"; // Hide the parent .main-btn-div element
          }
        });
      });
  
   

      












      // Get the UL where the links are added
const sectionScroller = document.getElementById('sectionscroller');

// Check if the UL exists
if (sectionScroller) {
    const dynamicContent = document.querySelector('.dynamcontent');

    // Check if .dynamcontent exists
    if (dynamicContent) {
        // Get all direct child headings (h2, h3, etc.) inside .dynamcontent
        const headings = dynamicContent.querySelectorAll(':scope > h2, :scope > h3');

        if (headings.length > 0) {
            // Create navigation links in the UL
            headings.forEach((heading, index) => {
                if (heading.tagName) {
                    if (!heading.id) {
                        heading.id = 'section-' + (index + 1); // Generate a unique ID
                    }

                    // Create an LI element
                    const li = document.createElement('li');

                    // Create an anchor link and set its href to the heading ID
                    const anchor = document.createElement('a');
                    anchor.href = '#' + heading.id;
                    anchor.textContent = heading.textContent || 'Untitled Section';

                    li.appendChild(anchor);
                    sectionScroller.appendChild(li);
                }
            });

            // Function to remove the "activelinker" class from all links
            const removeActiveClassFromAllLinks = () => {
                const allLinks = sectionScroller.querySelectorAll('a');
                allLinks.forEach(link => {
                    link.classList.remove('activelinker');
                });
            };

            // Function to determine which heading is closest to the top of the window
            const highlightClosestHeading = () => {
                let closestHeading = null;
                let closestDistance = Number.POSITIVE_INFINITY; // Initialize with a large number

                // Loop through each heading and calculate its distance from the top of the viewport
                headings.forEach((heading) => {
                    const distanceFromTop = Math.abs(heading.getBoundingClientRect().top);

                    // Find the heading closest to the top of the viewport
                    if (distanceFromTop < closestDistance) {
                        closestDistance = distanceFromTop;
                        closestHeading = heading;
                    }
                });

                // If we found the closest heading, activate its corresponding link
                if (closestHeading) {
                    const activeLink = sectionScroller.querySelector(`a[href="#${closestHeading.id}"]`);

                    // Remove the active class from all links
                    removeActiveClassFromAllLinks();

                    // Add the activelinker class to the closest heading's link
                    if (activeLink) {
                        activeLink.classList.add('activelinker');
                    }
                }
            };

            // Listen to the scroll event to update the active link
            window.addEventListener('scroll', highlightClosestHeading);

            // Call the function once on page load to set the initial active link
            highlightClosestHeading();
        } else {
            console.log('No headings found in .dynamcontent');
        }
    } else {
        console.log('.dynamcontent container not found');
    }
} else {
    console.log('#sectionscroller not found');
}







jQuery(document).ready(function($) {
  $('.newsletterform').on('submit', function(e) {
      e.preventDefault();
      var $form = $(this);
      var formData = $(this).serialize(); // Get form data

      $.ajax({
          url: $form.attr('action'), // URL to the WordPress admin-ajax
          type: 'POST',
          data: formData,
          success: function(response) {
              $form.find('.formconf').show();
          },
          error: function(response) {
              alert('Something went wrong. Please try again.');
          }
      });
  });
});






    });









    jQuery('a[href="#downloadpopup"]').on('click', function(e) {
      e.preventDefault();
      //  Show bootstrap modal with ID #DownloadexampleModaldloadpop
      jQuery('#DownloadexampleModaldloadpop').modal('show');
    });


    jQuery(document).ready(function ($) {
      $('.ajformdownload').on('submit', function (e) {
          e.preventDefault();

          console.log('nu downlo');
          $('.primarycontent').hide();
                      $('.succresponse').show();
          document.querySelector('#dloadsuccess').click();
          // Serialize form data
          var formData = $(this).serialize();
  
          $.ajax({
              type: 'POST',
              url: '/wp-admin/admin-ajax.php',
              data: {
                  action: 'send_contact_form',
                  form_data: formData
              },
              success: function (response) {
                  if (response.success) {
                      // Hide the primary content and show the success message
                      $('.primarycontent').hide();
                      $('.succresponse').show();

 
          

                    // fetch(jQuery('#fileurl').val())
                    //     .then(response => response.blob())
                    //     .then(blob => {
                    //         var url = window.URL.createObjectURL(blob);
                    //         var link = document.createElement('a');
                    //         link.href = url;
                    //         link.download = jQuery('#fileurl').val().split('/').pop();
                    //         document.body.appendChild(link);
                    //         link.click();
                    //         document.body.removeChild(link);
                    //         window.URL.revokeObjectURL(url);
                    //     })
                    //     .catch(() => {
                    //         alert('File download failed. Please try again.');
                    //     });
  
                      // Automatically download a file
                      // window.location.href = '';
                  }
              },
              error: function () {
                  alert('An error occurred. Please try again.');
              }
          });
      });
  });
  

  

  jQuery('a[href="#popupform"]').on('click', function(e) {
    e.preventDefault();
    //  Show bootstrap modal with ID #exampleModal
    jQuery('#exampleModalRegister').modal('show');

    setTimeout(function() {
      jQuery('.formloadme').each(function() {
        var src = jQuery(this).attr('data-iframesrc');
        var name = jQuery(this).attr('data-iframename');
        var iframeclass = jQuery(this).attr('data-iframeclass');
        
        // Remove existing iframe
        jQuery(this).find('iframe').remove();
        
        // Create new iframe element
        var $iframe = jQuery('<iframe>', {
            src: src,
            name: name,
            width: '100%',
            class: iframeclass
        });
        
        // Append iframe to DOM
        jQuery(this).append($iframe);
        
        // Add the load event listener
        const hasLoadedOnce = new WeakMap();
        
        $iframe.on('load', function () {
        const iframeEl = this;
        if (!hasLoadedOnce.get(iframeEl)) {
            hasLoadedOnce.set(iframeEl, true);
            return; // ← First load (form render), do nothing
        }

        console.log(`🎉 Form submitted in iframe`);
        jQuery('#exampleModalRegister').modal('hide');  // ← Move hide modal here
        jQuery('#exampleModalsuccessPopup').modal('show');
    });

        
      });
    }, 5);
  }
  );